module.exports = __webpack_public_path__ + "static/img/company page top img_desktop.313b6e3e.jpg";